exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sheets{margin:1rem}.sheets-create{margin-top:1rem}.sheets-links{background-color:white;filter:brightness(95%);transition:0.3s ease}.sheets-links:hover{filter:brightness(120%);background-color:white;position:relative;z-index:9999;pointer-events:auto;text-decoration:none}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/CheatSheets/CheatSheets.scss
// module id = 303
// module chunks = 0